// grafana-com returns a plain Conflict for several sign-up errors, so only the message tells this one apart.
const EMAIL_TAKEN_MESSAGE_PATTERN = /email (is )?already registered/i;

export const isEmailTakenError = (message?: string): boolean =>
  message ? EMAIL_TAKEN_MESSAGE_PATTERN.test(message) : false;
